import React, { PropTypes } from 'react';
import pluralize from 'pluralize';
import { Dialog, FontIcon, FlatButton, CircularProgress } from 'material-ui';
import SimpleTemplateList from '../../template-list/simple-template-list';
import PartnersChips from '../../generic-components/email-to-partners';
import { connect } from 'react-redux';
import {
  closeFinaliseDialog as closeFinaliseDialogAction,
  finalise as finaliseAction,
} from '../__storeFiles__/actions';
import supplierWizardCompleteImage from '../../../../../www/images/supplier-wizard-complete.svg';

const FinaliseDialog = props => {
  const {
    open,
    loadingBuyers,
    buyers,
    doc: {
      templates = [],
    },
    typeLabel,
    callingApi,
    sendUpdatesSuccess,
    closeFinaliseDialog,
    finalise,
  } = props;
  return (
    <Dialog
      open={open}
      title={<div className="flex-tc-sb">
        Finalise {typeLabel}
        <div onClick={closeFinaliseDialog}>
          <FontIcon className="tc-icon-close" style={{ fontSize: '24px', cursor: 'pointer' }} />
        </div>
      </div>}
      modal
      onRequestClose={closeFinaliseDialog}
      contentStyle={{ maxWidth: '880px', width: '880px' }}
      autoScrollBodyContent
      actions={
        sendUpdatesSuccess
        ? [<FlatButton
          key="dismiss"
          label="Dismiss"
          secondary
          onTouchTap={closeFinaliseDialog}
        />]
        : [
          <FlatButton
            key="cancel"
            label="Cancel"
            disabled={callingApi}
            primary
            onTouchTap={closeFinaliseDialog}
          />,
          <FlatButton
            key="confirm"
            label="Confirm"
            disabled={callingApi}
            secondary
            onTouchTap={finalise}
          />,
        ]
      }
    >
      {
        (() => {
          if (loadingBuyers) {
            return (
              <div style={{ marginTop: '32px', textAlign: 'center' }}>
                <CircularProgress size={120} />
              </div>
            );
          }
          return (
            <div style={{ display: 'flex', alignItems: 'stretch' }}>
              <div style={{ width: buyers.length ? '50%' : '100%', padding: '16px 8px' }}>
                {
                  sendUpdatesSuccess ? (
                    <p style={{ textAlign: 'center' }}>
                      <img src={supplierWizardCompleteImage} style={{ width: '24px', marginRight: '4px' }}/>
                      <span>{
                        pluralize('This', templates.length)
                      } {
                        pluralize('template', templates.length)
                      } {
                        pluralize('has', templates.length)
                      } been successfully updated.</span>
                      <img src={supplierWizardCompleteImage} style={{ width: '24px', marginLeft: '4px' }} />
                    </p>
                  ) : (
                    <p>The following {pluralize('template', templates.length)} will be automatically updated:</p>
                  )
                }
                {
                  templates.length
                    ? (
                      <SimpleTemplateList
                        templates={templates}
                        makeItShorter
                      />
                    )
                    : (
                      <div style={{ padding: '32px 0' }}>
                        This {
                        typeLabel
                      } template is not assoicated with any templates.
                      </div>
                    )
                }
              </div>
              {
                Boolean(buyers.length) && (
                  <div style={{ width: '50%', borderLeft: '1px solid #e0e0e0', padding: '16px 8px' }}>
                    {
                      sendUpdatesSuccess ? (
                        <p style={{ textAlign: 'center' }}>
                          <img src={supplierWizardCompleteImage} style={{ width: '24px', marginRight: '4px' }}/>
                          <span>
                            We have successfully issued updates to {
                            pluralize('this', buyers.length)
                          } {
                            pluralize('partner', buyers.length)
                          }.</span>
                          <img src={supplierWizardCompleteImage} style={{ width: '24px', marginLeft: '4px' }} />
                        </p>
                      ) : (
                        <p>We will issue updates to the following {pluralize('partner', buyers.length)}.</p>
                      )
                    }
                    <PartnersChips
                      partners={buyers.map(buyer => ({
                        ...buyer,
                        subText: `(${
                          buyer.templateIds.length
                        } ${pluralize('contract', buyer.templateIds.length)})`,
                      }))}
                      justPartners
                      defaultShowNumOfPartners={8}
                    />
                  </div>
                )
              }
            </div>
          );
        })()
      }
    </Dialog>
  );
};

FinaliseDialog.propTypes = {
  open: PropTypes.bool,
  closeFinaliseDialog: PropTypes.func,
  doc: PropTypes.object,
  typeLabel: PropTypes.string,
  finalise: PropTypes.func,
  callingApi: PropTypes.bool,
  finaliseSuccess: PropTypes.bool,
  sendUpdatesSuccess: PropTypes.bool,
  loadingBuyers: PropTypes.bool,
  buyers: PropTypes.array,
};

const mapStateToProps = ({
 contracting: {
   masterTemplate: {
     docs,
     finaliseDialog,
   },
 },
}) => {
  return {
    doc: docs[docs.currentId] || {},
    ...finaliseDialog,
  };
};
export default connect(mapStateToProps, {
  closeFinaliseDialog: closeFinaliseDialogAction,
  finalise: finaliseAction,
})(FinaliseDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/dialogs/finalise-dialog.jsx